import {
    FormLabel,
    FormControl,
    FormControlLabel,
    RadioGroup as ComponentRadioGroup,
} from "@mui/material";

import Radio from "../Radio";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";

import { ICodename } from "../../commons/interfaces";

interface IProps {
    value: any;
    label: string;
    isRow?: boolean;
    disabled?: boolean;
    dataMulti: ICodename[];
    onChangeValue?: (value: any) => void;
}

const RadioGroup: React.FC<IProps> = (props: IProps) => {
    const onChange = (event: any, value: string) => {
        if (Helpers.isFunction(props.onChangeValue)) {
            props.onChangeValue(event.target?.value);
        }
    };

    return (
        <FormControl disabled={props.disabled}>
            <FormLabel>
                <Typography color="secondary" variant="caption" fontWeight="regular" sx={{ lineHeight: 0, fontSize: "0.825rem" }}>
                    {props.label}
                </Typography>
            </FormLabel>
            <ComponentRadioGroup
                row={props.isRow || false}
                value={props.value}
                onChange={onChange}
            >
                {props.dataMulti.map((item, index: number) => (
                    <FormControlLabel
                        key={index}
                        label={item.name}
                        value={item.code}
                        control={<Radio />}
                        disabled={props.disabled}
                        sx={{ mb: 0, mt: 0, ml: 0 }}
                    />
                ))}
            </ComponentRadioGroup>
        </FormControl>

    );
};

export default RadioGroup;
